<template>
  <div class="section">
    <div class="card z-depth-0">
      <div class="card-content" v-if="enrollee">
        <!-- Main -->
        <div class="row">
          <div class="col s8">
            <p>{{ capWords(enrollee.client_name) }}</p>
            <h5>
              {{ capWords(enrollee.name) }}
              <sup>{{ showAgeSex(enrollee.dob, enrollee.sex) }}</sup> &nbsp;
              <a href="#" class="orange-text"><i class="material-icons teal lighten-4" title="clear"
                  @click.prevent="handleBack()">clear</i></a>
            </h5>
            <p>({{ enrollee.enrollee_number }})</p>
            <span v-if="!forDelete">
              <span v-if="enrollee && 'encounter_date' in enrollee">
                <p>
                  <br />
                  <span class="chip blue-grey lighten-4">
                    {{
                      new Date(enrollee.encounter_date).toLocaleString(undefined, {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    }}
                  </span>

                  <span class="chip teal lighten-4" v-if="enrollee && enrollee?.encounter_date_end">
                    {{
                      new Date(enrollee.encounter_date_end).toLocaleString(undefined, {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    }}
                  </span> <i class="tiny material-icons red-text clickable" title="Reset date"
                    @click="handleDateReset()" v-if="!enrollee?.encounter_date_set">cancel</i>
                </p>
              </span>
              <span v-else>
                <p>Encounter Dates <em>not</em> set</p>
              </span>
            </span>
          </div>

          <div class="col s4">
            <img :src="enrollee.profile_img" width="96" class="circle responsive-img right"
              v-if="enrollee.profile_img" />
            <img :src="`https://ui-avatars.com/api/?name=${enrollee.name}&background=random&size=128`" width="96"
              class="circle responsive-img right" v-else />
          </div>
        </div>

        <div class="row grey lighten-4" v-if="forDelete">
          <p><br /></p>
          <div class="col s12">
            <a class="waves-effect waves-light btn-large teal left" title="Back" :class="{ 'disabled': isSubmitting }"
              @click.prevent="handleDeleteEncounter('back')">
              <i class="medium material-icons left">chevron_left</i>Go back
            </a>

            <a class="waves-effect waves-light btn-large red right" title="Delete All"
              :class="{ 'disabled': isSubmitting }" @click.prevent="handleDeleteEncounter('confirm_delete')">
              <i class="medium material-icons left">delete</i>Confirm Delete for {{ capWords(enrollee.name) }}
            </a>
          </div>
          <p><br /></p>
        </div>
      </div>

      <!-- Search Enrollee -->
      <template v-if="!enrollee">

        <template v-if="!enrolleeSearch">

          <div class="card-panel" :class="{ 'red lighten-5': error }">
          <div class="row">
            <div class="col s3">
              <div class="input-field">
                <input type="text" id="enrolleeId" v-model="enrolleeId" />
                <label for="enrolleeId">Enrollee ID</label>
              </div>
            </div>
            <div class="col s6">
              <div class="input-field">
                <input type="text" id="enrolleeName" v-model="enrolleeName" />
                <label for="enrolleeName">Enrollee Name</label>
              </div>
            </div>
            <div class="col s3">
              <p>
                <button class="waves-effect waves-light btn-large right" :class="{
                  disabled: !enrolleeId || !enrolleeName,
                }" @click="handleAddEnrollee">
                  <i class="material-icons right" v-if="!isLoading">chevron_right</i> Next
                </button>
              </p>
            </div>
            <div clas="row" v-if="error">
              <div class="col s12">
                <span class="left badge red white-text text-darken-2">{{ error }}</span>
              </div>
            </div>
          </div>
        </div>
        </template>

        <template v-else>
        <!-- Single Search -->
        <div class="card-panel" :class="{ 'red lighten-5': error }">
          <div class="row">
            <div class="col s12 m1 clickable" @click.prevent="handleBack()"><i class="large material-icons right" title="Go Back">chevron_left</i></div>
            <div class="col s12 m8">
              <div class="input-field">
                <input type="text" id="enrolleeId" v-model="enrolleeId" @focus="handleClearID('id')" />
                <label for="enrolleeId">Enrollee ID</label>
                <div class="progresss" v-if="isLoading">
                  <div class="indeterminate"></div>
                </div>
              </div>
            </div>
            <div class="col s12 m3">
              <p>
                <button class="waves-effect waves-light btn-large right" :class="{
                  disabled: !enrolleeId || isLoading,
                }" @click="handleSearch">
                  <i class="material-icons right" v-if="!isLoading">chevron_right</i>{{ isLoading ? "Searching..." :
                    "Search" }}
                </button>
              </p>
            </div>
            <div clas="row" v-if="error">
              <div class="col s12">
                <span class="left badge red white-text text-darken-2">{{ error }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Confirmation for more than multiple enrollees -->
        <div class="card yellow lighten-4" v-for="enrollee in enrolleeGroup" :key="enrollee.id">
          <div class="card-content">
            <div class="row">
              <div class="col s10">
                <p class="grey-text text-darken-2">{{ cluster.month.name }} {{ cluster.year.name }} List</p>
                <h5>{{ capWords(enrollee?.name) }} <small>({{ enrollee?.enrollee_number }})</small></h5>
                <span class="new badge left grey darken-2" data-badge-caption="Scheme">{{
                  enrollee?.scheme.name.toUpperCase()
                }}</span>
              </div>
              <div class="col s2">
                <a class="btn-floating btn-large waves-effect waves-light light-blue lighten-2 pulse right"><i
                    class="material-icons" @click.prevent="handleStart(enrollee)" title="details">chevron_right</i></a>
              </div>
            </div>
          </div>
        </div>
        </template>
      </template>
      <!-- End Search Enrollee -->

      <div v-else>
        <!-- Encounter Starts: Date Form -->
        <div class="card-panel" :class="{ 'red lighten-5': error }" v-if="!enrollee?.encounter_date">
          <div class="row">
            <div class="col s12">
              <span class="card-title">Start <em>of</em> Encounter</span>
            </div>
            <div class="col s5 m3">
              <div class="input-field">
                <input type="text" id="enounterDate" v-model="encounterDate" @focus="handleClearID('date')" />
                <label for="encounterDate">Day</label>
              </div>
            </div>
            <div class="col s7 m3">
              <div class="input-field">
                <input type="text" id="month" :value="cluster.month.name" disabled />
                <label class="active" for="month">Month</label>
              </div>
            </div>
            <div class="col s5 m3">
              <div class="input-field">
                <input type="text" id="year" :value="cluster.year.name" disabled />
                <label class="active" for="year">Year</label>
              </div>
            </div>
            <div class="col s7 m3">
              <p>
                <button class="waves-effect waves-light btn-large right" :class="{
                  disabled: !encounterDate || isLoading,
                }" @click="handleEncounterDate">
                  <i class="material-icons right">{{
                    isLoading ? "hourglass_empty" : "chevron_right"
                  }}</i>{{ isLoading ? "Going..." : "Next" }}
                </button>
              </p>
            </div>
          </div>
        </div>

        <!-- Encounter Ends: Date Form -->
        <template v-if="(enrollee?.encounter_date && !enrollee?.encounter_date_end)">
          <!-- Selections -->
          <div class="card-panel" :class="{ 'red lighten-5': error }">
            <div class="row" v-if="addOns">
              <div class="col s12">
                <span class="card-title">Special Fields</span>
              </div>
              <div class="col s12">
                <div class="input-field">
                  <input type="text" id="doctor" v-model="doctor" required />
                  <label class="active orange-text text-darken-2" for="doctor">Attending Doctor (*)</label>
                </div>
              </div>
              <div class="col s12">
                <div class="input-field">
                  <input type="text" id="age" v-model="patientAge" />
                  <label class="active teal-text text-darken-2" for="age">Patient Age</label>
                </div>
              </div>
              <div class="col s12">
                <div class="input-field">
                  <input type="text" id="complaint" v-model="presentingComplaint" />
                  <label class="active teal-text" for="complaint">Presenting Complaints</label>
                </div>
              </div>
              <div class="col s12">
                <div class="input-field">
                  <input type="text" id="finding" v-model="examinationFinding" />
                  <label class="active teal-text" for="finding">Examination Finding</label>
                </div>
              </div>
              <div class="col s12">
                <div class="input-field">
                  <input type="text" id="finding" v-model="requestedInvestigation" />
                  <label class="active teal-text" for="investigations">Investigations (copy)</label>
                </div>
              </div>
              <div class="col s12">
                <p>
                  <button class="waves-effect waves-light btn-large right" :class="{
                    disabled: !doctor || isLoading
                  }" @click="handleSpecial()">
                    <i class="material-icons right">{{
                      isLoading ? "hourglass_empty" : "chevron_right"
                      }}</i>{{ isLoading ? "Adding..." : "Add" }}
                  </button>
                </p>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col s12">
                <span class="card-title">End <em>of</em> Encounter</span>
              </div>
              <div class="col s5 m3">
                <div class="input-field">
                  <input type="text" id="enounterDateEnd" v-model="encounterDateEnd" @focus="handleClearID('date')" />
                  <label class="active" for="encounterDateEnd">Day</label>
                </div>
              </div>
              <div class="col s7 m3">
                <div class="input-field">
                  <FilterSimpleDiv inputId="filterDurationMonth" fieldName="Select Month"
                    :data="filterDurationMonthData" :placeHolder="selectedDurationMonth?.name" :search="false"
                    @selected="handlePick" />
                </div>
              </div>
              <div class="col s5 m3">
                <div class="input-field">
                  <FilterSimpleDiv inputId="filterDurationYear" fieldName="Select Year" :data="filterDurationYearData"
                    :placeHolder="selectedDurationYear?.name" :search="false" @selected="handlePick" />
                </div>
              </div>
              <div class="col s7 m3">
                <p>
                  <button class="waves-effect waves-light btn-large right" :class="{
                    disabled: !encounterDateEnd || !selectedDurationMonth || !selectedDurationYear || isLoading,
                  }" @click="handleEncounterDateEnd()">
                    <i class="material-icons right">{{
                      isLoading ? "hourglass_empty" : "chevron_right"
                      }}</i>{{ isLoading ? "Setting ..." : "Set" }}
                  </button>
                </p>
              </div>
            </div>
          </div>
          <!-- Claims Summary -->
          <div class="card-content" v-if="enrollee?.encounter_date_set">
            <!-- <span class="card-title">Summary</span> -->
            <ol id="item-list" class="collection">
              <li class="collection-item" v-for="claim in enrollee?.claims" :key="claim.id">
                <span v-if="claim.status === 'a'">
                  <b>{{ capWords(claim.claim) }}</b> x {{ claim.qty }} (<em>Sent Amount</em>: ₦{{
                    claim.amt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}) <span class="chip blue lighten-5 pointable" v-if="claim.amt == 0 && claim.authorization !== 'y'"
                    title="capitated item">Cap</span>

                  <!-- Reviewed claim -->
                  <span class="brown-text" v-if="claim.authorization === 'y'">
                    <b> => </b>
                    <span class="blue-text tooltipped pointable" data-position="top" :data-tooltip="claim.comment"
                      v-if="claim.comment"> ({{
                        claim.authorization_code }}) </span>
                    <span class="black-text" v-else> ({{ claim.authorization_code }}) </span>
                  </span>
                </span>
                <span v-if="claim.status === 'd'">
                  <s>{{ capWords(claim.item) }} x {{ claim.sent_qty }} (Amount Sent: ₦{{
                    Number(claim.sent_price)
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }})</s>
                  <b><span class="info-item tooltipped pointable" data-position="top"
                      :data-tooltip="capWords(claim.comment)">
                      <i class="material-icons grey-text">help</i>
                    </span></b>
                </span>
              </li>
            </ol>
          </div>
        </template>

        <div class="progresssave" v-if="isLoading">
          <div class="indeterminate"></div>
        </div>

        <div id="claim"></div>

        <!-- Displays -->
        <template v-if="enrollee?.encounter_date_end && !forDelete">
          <!-- Diagnosis -->
          <div class="row grey lighten-4" v-if="diagnosisList.length">
            <div class="col s12">
              <div class="card-content yellow lighten-1">
                <span class="black-text text-lighten-5">
                  <p>
                    Diagnosis: {{ diagnosisList.join(", ").toUpperCase() }}
                    <a href="#" class="secondary-content edit-black-item right" v-if="cluster?.status === 'q'">
                      <i class="small material-icons" :class="{
                        'black-text': !resetDiagnosis,
                        'blue-text': resetDiagnosis,
                      }" title="edit diagnosis" @click.prevent="handleReviewDiagnosis"
                        v-if="!enrollee?.encounter_date_set || enrollee?.scheme_id === 1">edit</i>
                      <i class="small material-icons pointable" title="locked" v-else>lock</i>
                    </a>
                  </p>
                </span>
              </div>
            </div>
            <template v-if="enrollee?.scheme_id === 3">
              <!-- Addons -->
              <!-- doctor loaded means review was clicked -->
              <div class="row card-content grey lighten-4" v-if="doctor">
                <div class="col s12">
                  <br />
                </div>
                <div class="col s12">
                  <span class="card-title">Update Patient Record</span>
                </div>
                <div class="col s12">
                  <div class="input-field">
                    <input type="text" id="doctor" v-model="doctor" required />
                    <label class="active orange-text text-darken-2" for="doctor">Attending Doctor (*)</label>
                  </div>
                </div>
                <div class="col s12">
                  <div class="input-field">
                    <input type="text" id="age" v-model="patientAge" />
                    <label class="active teal-text text-darken-2" for="age">Patient Age</label>
                  </div>
                </div>
                <div class="col s12">
                  <div class="input-field">
                    <input type="text" id="complaint" v-model="presentingComplaint" />
                    <label class="active teal-text" for="complaint">Presenting Complaints</label>
                  </div>
                </div>
                <div class="col s12">
                  <div class="input-field">
                    <input type="text" id="finding" v-model="examinationFinding" />
                    <label class="active teal-text" for="finding">Examination Finding</label>
                  </div>
                </div>
                <div class="col s12">
                  <div class="input-field">
                    <input type="text" id="finding" v-model="requestedInvestigation" />
                    <label class="active teal-text" for="investigations">Investigations (copy)</label>
                  </div>
                </div>
                <div class="col s12">
                  <p>
                    <button class="waves-effect waves-light btn-large blue darken-1 right" :class="{
                      disabled: !doctor || isLoading
                    }" @click="handleAddOn()">
                      <i class="material-icons right">{{
                        isLoading ? "hourglass_empty" : "chevron_right"
                        }}</i>{{ isLoading ? "Updating..." : "Update" }}
                    </button>
                  </p>
                </div>
              </div>
              <!-- Addons display -->
              <div class="col s12" v-else>
                <div class="card-content grey lighten-1">
                  <a href="#" class="secondary-content edit-black-item right">
                    <i class="small orange-text text-darken-2 material-icons" title="redo"
                      @click.prevent="handleReviewAddOn()">autorenew</i>
                  </a>
                  <span class="black-text">
                    <p>
                      Attending Doctor: {{ enrollee?.stores?.doctor }}
                    </p>
                    <p>
                      Patient Age: {{ enrollee?.stores?.age }}
                    </p>
                    <p>
                      Presenting Complaints: {{ enrollee?.stores?.complaint }}
                    </p>
                    <p>
                      Examination Finding: {{ enrollee?.stores?.finding }}
                    </p>
                    <p>
                      Investigations: {{ enrollee?.stores?.investigation }}
                    </p>
                  </span>
                </div>
              </div>
            </template>
          </div>

          <!-- Add claim -->
          <AddClaimProvider 
            :turl="tariffLookup" :type="type"
            :next="next" :editDiagnosis="resetDiagnosis" :claimItem="claim" :reload="encounter" @update="handleUpdate"
            @claims-updated="handleClaimsUpdated"
            @clear="handleClear" />

          <!-- Claims -->
          <div class="card" v-if="claimsDisplayCard">
            <div class="card-content">
              <span class="card-title">Item(s)
                <span class="chip orange-text text-accent-3 pointable" :title="enrollee.picked_provider"
                  v-if="enrollee?.scheme_id === 3 && enrollee.picked_provider_id && enrollee.provider_id && enrollee.picked_provider_id !== enrollee.provider_id">
                  Referral </span>

                <a class="btn-medium waves-effect waves-light red lighten-2 secondary-content chip right"
                  v-if="enrollee?.scheme_id === 3"><i class="material-icons white-text" @click.prevent="handleDownload()"
                    title="download encounter">download</i>
                </a>
              </span>

              <!-- List claims -->
              <ol id="item-list" class="collection">
                <li class="collection-item" v-for="claim in claims" :key="claim.id">

                  <!-- Approved Items -->
                  <span v-if="claim.status == 'a'">
                    <b>{{ capWords(claim.claim) }}</b> x {{ claim.qty }} (<em>Sent Amount</em>: ₦{{
                      claim.amt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}) <span class="chip blue lighten-5 pointable" v-if="claim.amt == 0 && claim.authorization !== 'y'"
                      title="capitated item">Cap</span>

                    <!-- Reviewed claim -->
                    <span class="brown-text" v-if="claim.authorization === 'y'">
                      <b> => </b>
                      <span class="blue-text tooltipped pointable" data-position="top" :data-tooltip="claim.comment"
                        v-if="claim.comment"> ({{
                          claim.authorization_code }}) </span>
                      <span class="black-text" v-else> ({{ claim.authorization_code }}) </span>
                    </span>

                    <span class="hide-on-small-only" v-if="cluster.status === 'q'">
                      <a href="#" class="secondary-content cancel-item" @click.prevent="handleDelete(claim)"
                        title="Remove item"><i class="material-icons" :class="{
                          'grey-text': deleteId != claim.id,
                          'red-text': deleteId == claim.id,
                        }">cancel</i></a>
                    </span>
                  </span>

                  <!-- Deleted Items -->
                  <span v-else>
                    <s>{{ capWords(claim.item) }} x {{ claim.sent_qty }} (Amount Sent: ₦{{
                      Number(claim.sent_price)
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }})</s>
                    <b><span class="info-item tooltipped pointable" data-position="top"
                        :data-tooltip="capWords(claim.comment)">
                        <i class="material-icons grey-text">help</i>
                      </span></b>

                    <span class="hide-on-small-only" v-if="cluster.status === 'q'">
                      <a href="#" class="secondary-content cancel-item" @click.prevent="handleDelete(claim)"
                        title="Remove item"><i class="material-icons" :class="{
                          'grey-text': deleteId != claim.id,
                          'red-text': deleteId == claim.id,
                        }">cancel</i></a>
                    </span>
                  </span>

                </li>
              </ol>

              <!-- Claims Submit -->
              <div v-if="claimsSubmitCard">
                <!-- Total -->
                <ul id="item-list" class="collection">
                  <li class="collection-item pull-right">
                    <b>Total</b> (Sent Amount):
                    <b><span class="blue-text text-darken-2">₦{{ totalSent() }}</span></b>
                  </li>
                </ul>

                  <div class="billing-completion-error" role="alert" v-if="completionError">
                    {{ completionError }}
                  </div>

                  <!-- Submit -->
                <span class="row" v-if="cluster.status === 'q'">
                  <br />
                  <a class="waves-effect waves-light btn-large red col s12 m2 left" title="Delete All"
                    :class="{ 'disabled': isLoading || deleteId || cluster?.status !== 'q' || enrollee?.encounter_date_set }"
                    @click.prevent="handleDeleteEncounter('delete')">
                    <i class="medium material-icons left">delete</i>Delete</a>

                  <a class="waves-effect waves-light btn-large black col s12 m2 left"
                    :class="{ 'disabled': isLoading || deleteId || cluster?.status !== 'q' }"
                    @click.prevent="handleNext('moreClaims')">
                    <i class="medium material-icons left">add</i>Add Item</a>

                  <!-- Breaker -->
                  <span class="co1 m5"></span>

                  <a class="waves-effect waves-light btn-large col s12 m3 right"
                    :class="{ 'disabled': isLoading || deleteId, 'teal': enrollee?.status === 'q', 'grey darken-1': enrollee?.status !== 'q' }"
                    @click.prevent="handleSubmit(true, true)" v-if="enrollee?.encounter_date_set">
                    <span v-if="enrollee?.status === 'q'"><i
                        class="large material-icons left">check_circle</i>Complete</span>
                    <span v-else><i class="large material-icons left">chevron_right</i>Okay</span>
                  </a>

                  <a class="waves-effect waves-light btn-large green col s12 m3 right"
                    :class="{ 'disabled': isLoading || deleteId }" @click.prevent="handleCreate()" v-else>
                    <i class="large material-icons left">check_circle</i>Complete
                  </a>

                  <br />
                  <br />
                  <br />
                </span>
                <!-- Submitted -->
                <span class="row" v-else>
                  <br />

                  <!-- Breaker -->
                  <span class="co1 m9"></span>

                  <a class="waves-effect waves-light btn-large black col s12 m3 right"
                    @click.prevent="handleSubmit(true)">
                    <i class="large material-icons left">chevron_left</i>Back
                  </a>

                  <br />
                  <br />
                  <br />
                </span>
              </div>
            </div>
          </div>

          <!-- Sumbmitting -->
          <div class="progress" v-if="isSubmitting || deleteId">
            <div class="indeterminate"></div>
          </div>

        </template>
      </div>

    </div>
  </div>
</template>


<script>
import { ref, onMounted, computed, watchEffect, nextTick } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ageSex, capWordsFx } from "@/composables/fxLibrary/coreFx";
import { totalSentInputFx } from "@/composables/calFunction/cal";
import getItemsOfItems from "@/composables/getItemsOfItems";
import putItem from "@/composables/putItem";
import { dryDeleteEncounter, addEncounterWithClaims } from "@/composables/serverCaller/serverCaller";
import AddClaimProvider from "@/components/claim/AddClaimProviderComponent.vue";
import FilterSimpleDiv from "@/components/search/FilterSimpleDiv.vue";
import M from "materialize-css";

export default {
  name: "EnrolleeBillComponent",
  props: ["cluster", "encounter"],
  emits: ["next", "back"],
  components: { AddClaimProvider, FilterSimpleDiv },
  setup(props, context) {
    const lock = ref(true);
    const addOns = ref(false); // for all schemes at first!
    const enrolleeSearch = ref(false); //use manual for now
    const doctor = ref(null);
    const patientAge = ref(null);
    const presentingComplaint = ref(null);
    const examinationFinding = ref(null);
    const requestedInvestigation = ref(null);
    const isLoading = ref(false);
    const isSubmitting = ref(false);
    const response = ref(null);
    const responseDurationYearDefault = ref(null);
    const responseDurationMonthDefault = ref(null);
    const enrolleeGroup = ref([]);
    const enrolleeName = ref(null);
    const enrolleeId = ref(null);
    const encounterDate = ref(null);
    const encounterDateEnd = ref(null);
    const error = ref(false);
    const editId = ref(null);
    const editClaim = ref(null);
    const forDelete = ref(false);
    const deleteId = ref(null);
    const deleteClaim = ref(null);
    const submitPulse = ref(false);
    const selectedItem = ref(null);
    const selectedDurationYear = ref(null);
    const selectedDurationMonth = ref(null);
    const claimsDisplayCard = ref(false);
    const claimsSubmitCard = ref(false);
    const diagnosisList = ref([]);
    const completionError = ref("");
    const resetDiagnosis = ref(false);
    const type = ref("claim"); // keep claim open after input
    const next = ref("next");
    const claimsList = ref([]);
    const claim = ref(null);
    const cache = ref({});
    const healthClaimForm = ref(null);

    const tariffLookup = computed(() => ({
      payerId: response.value?.payer_id,
      sid: props.cluster?.scheme_id,
      pid: props.cluster?.provider_id,
    }));

    // vue router
    const router = useRouter();

    // store
    const store = useStore();

    // provider
    const provider = ref(store.state.user?.coy);

    // admission
    const admission = ref(false);

    const hasBillingDiagnosis = () => {
      const enteredDiagnosis = diagnosisList.value
        .map((entry) => String(entry || "").trim())
        .filter(Boolean)
        .join(" ");
      const savedDiagnosis = response.value?.encounter_date_set
        ? String(response.value?.diagnosis || "").trim()
        : "";
      return Boolean(enteredDiagnosis || savedDiagnosis);
    };

    const requireBillingDiagnosis = async () => {
      completionError.value = "Add a diagnosis before completing this billing encounter.";
      await nextTick();

      const editorCard = document.querySelector(".provider-diagnosis-card");
      if (editorCard) {
        const top = editorCard.getBoundingClientRect().top + window.scrollY - 104;
        window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
      }
    };

    // toolTip
    const toolTip = () => {
      var elems = document.querySelectorAll(".tooltipped");
      M.Tooltip.init(elems, {});
    };

    // restart toolTip
    const restartComments = () => {
      // load comment
      setTimeout(() => {
        toolTip();
      }, 2000);
    };

    // start comments
    onMounted(() => {
      restartComments();
    });

    // Duration (Month)
    const filterDurationMonthData = computed(() => {
      // start
      let val = null;

      let valPlus;

      if (responseDurationMonthDefault.value) {
        if (responseDurationMonthDefault.value.key == "filterDurationMonth") {
          valPlus = responseDurationMonthDefault.value.value.reduce(
            (newArr, x) => {
              newArr[x.period] = null;
              return newArr;
            },
            {}
          );
          val = { ...val, ...valPlus };
        }
      }

      // return final
      return val;
    });

    // Duration (Year)
    const filterDurationYearData = computed(() => {
      // start
      let val = null;

      let valPlus;

      if (responseDurationYearDefault.value) {
        if (responseDurationYearDefault.value.key == "filterDurationYear") {
          valPlus = responseDurationYearDefault.value.value.reduce(
            (newArr, x) => {
              newArr[x.period] = null;
              return newArr;
            },
            {}
          );
          val = { ...val, ...valPlus };
        }
      }

      // return final
      return val;
    });

    // filter (Initialize)
    onMounted(() => {
      // initialize filterDuration
      let val = [
        { period: "January", month: 1 },
        { period: "February", month: 2 },
        { period: "March", month: 3 },
        { period: "April", month: 4 },
        { period: "May", month: 5 },
        { period: "June", month: 6 },
        { period: "July", month: 7 },
        { period: "August", month: 8 },
        { period: "September", month: 9 },
        { period: "October", month: 10 },
        { period: "November", month: 11 },
        { period: "December", month: 12 },
      ];
      // set
      responseDurationMonthDefault.value = {
        key: "filterDurationMonth",
        value: val,
      };
    });

    // filter (Initialize)
    onMounted(() => {
      // initialize filterDuration
      let val = [
        { period: props.cluster.year.search, year: props.cluster.year.search },
        { period: props.cluster.year.search + 1, year: props.cluster.year.search + 1 },
      ];
      // set
      responseDurationYearDefault.value = {
        key: "filterDurationYear",
        value: val,
      };
    });

    // start
    onMounted(() => {
      // check reload
      if (props.encounter) {
        // re-set
        response.value = props.encounter;
      }
    });

    //from functions
    const capWords = (val) => {
      return capWordsFx(val);
    };

    // total calculations
    const totalSent = () => {
      if (claims.value?.length) {
        return totalSentInputFx({ claims: claims.value });
      } else {
        return 0;
      }
    }

    // get function
    const getSearchItemsFromApi = (table, match) => {
      // loading starts
      isLoading.value = true;
      // clear error
      error.value = null;

      (async () => {
        const { res } = await getItemsOfItems(table, match);

        if (res.value && res.value.status) {
          if (res.value.data.length === 1) {
            // display the options (go straight)
            response.value = res.value.data[0];
          } else {
            // display the options
            enrolleeGroup.value = res.value.data;
          }
        } else {
          error.value = `Enrollee not on ${props.cluster.month.name} ${props.cluster.year.name} List!`;
          response.value = null; // clear standing response
        }

        // page is ready, loading is complete
        isLoading.value = false;
      })();
    };

    // ageSex
    const showAgeSex = (dob, sex) => {
      const { fx } = ageSex(dob, sex);
      return fx.value;
    };

    // download
    const handleDownload = async () => {
      // set admission
      if (toMidnightUTC(response.value.encounter_date_end) > toMidnightUTC(response.value.encounter_date)) {
        admission.value = true;
      }

      // Wait for the next tick to ensure the child component is fully rendered
      await nextTick();

      // Call the downloadPdf method in the child component
      if (healthClaimForm.value) {
        healthClaimForm.value.downloadPdf();
      } else {
        console.error('Child component is not available.');
      }
    }

    // clear all special
    const clearAllSpecial = () => {
      // clear
      doctor.value = null;
      patientAge.value = null;
      presentingComplaint.value = null;
      examinationFinding.value = null;
      requestedInvestigation.value = null;
    }

    // start
    const handleStart = (val) => {
      // set
      response.value = val;
    }

    // add enrollee (Manual)
    const handleAddEnrollee = () => {
     response.value = {
      enrollee_number: enrolleeId.value,
      name: enrolleeName.value,
      payer_id: props.cluster.payer_id,
      scheme: props.cluster.scheme,
      scheme_id: props.cluster.scheme_id,
     }

     console.log(response.value);
    }

    // search
    const handleSearch = () => {
      // loading starts
      isLoading.value = true;
      // val
      let date = props.cluster.month_year.split("_");
      let val = `payer_id=${props?.cluster?.payer_id}&scheme_id=${props?.cluster?.scheme_id}&m=${date[0]}&y=${date[1]}&q=${enrolleeId.value.trim()}`;
      // search: 0 = provider_id
      getSearchItemsFromApi("operator/enrollee/encounter/checker", `0?${val}`);
    };

    // to Mid night
    const toMidnightUTC = (date) => {
      const d = new Date(date);
      return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    };

    // encounter start
    const handleEncounterDate = () => {
      // clear error
      // Error
      error.value = null;

      // Create a new Date object
      var date = new Date(
        Date.UTC(
          props.cluster.year.search,
          props.cluster.month.search - 1,
          encounterDate.value,
          0,
          0,
          0
        )
      );

      // Check validity of Date
      if (
        date.getFullYear() == props.cluster.year.search &&
        date.getMonth() == props.cluster.month.search - 1 &&
        date.getDate() == encounterDate.value
      ) {
        // Format the date
        var formattedDate = date.toISOString().slice(0, 19).replace("T", " ");

        // Set encounter date
        response.value.encounter_date = formattedDate;

        // start encounter day
        encounterDateEnd.value = date.getDate();

        // cluster month
        let clusterMonth = responseDurationMonthDefault.value.value.find(x => x.month === props.cluster.month.search);

        // month
        selectedDurationMonth.value = {
          name: clusterMonth.period,
          search: props.cluster.month.search,
        };

        // year
        selectedDurationYear.value = {
          name: props.cluster.year.search,
          search: props.cluster.year.search,
        };

      } else {
        error.value = "Date is Invalid!";
      }
    };

    // encounter end
    const handleEncounterDateEnd = async () => {
      // clear error
      // Error
      error.value = null;

      // Create a new Date object
      var date = new Date(
        Date.UTC(
          selectedDurationYear.value.search,
          selectedDurationMonth.value.search - 1,
          encounterDateEnd.value,
          0,
          0,
          0
        )
      );

      // Check validity of Date
      if (
        date.getFullYear() == selectedDurationYear.value.search &&
        date.getMonth() == selectedDurationMonth.value.search - 1 &&
        date.getDate() == encounterDateEnd.value
      ) {
        // Format the date
        var formattedDate = date.toISOString().slice(0, 19).replace("T", " ");
        // check is date is properly set
        if (toMidnightUTC(formattedDate) < toMidnightUTC(response.value.encounter_date)) {
          // Error
          error.value = "Encounter Date End is Invalid!";
        } else {

          // PRIVATE BYPASS ADDONS
          // if (props?.encounter?.scheme_id === 1) { addOns.value = true }

          // MOVE FROM HERE 
          // ORANGHIS == 3
          if (addOns.value || props?.encounter?.scheme_id !== 3) { // after special has been included!

            // start
            isLoading.value = true;

            // stores
            let newStores = { ...response.value?.stores }
            newStores.doctor = doctor.value;
            newStores.age = patientAge.value;
            newStores.complaint = presentingComplaint.value;
            newStores.finding = examinationFinding.value;
            newStores.investigation = requestedInvestigation.value;
            // all others are kept intact!

            // save encounter after end encounter date set
            if (response.value?.encounter_date_set) {

              // function
              if (response.value.status === "q") {

                // start
                const newVal = {
                  id: response.value.id,
                  encounter_date_end: formattedDate,
                  stores: newStores,
                  // status: "p", // set away from q
                };

                // post item
                const { res } = await putItem(
                  "encounter",
                  response.value.id,
                  newVal,
                );

                if (res.value) {
                  // reset entire encounter data
                  response.value = res.value.data;
                  handleSubmit(false);
                  // kill addOns
                  addOns.value = false;
                  // clear
                  clearAllSpecial();
                } else {
                  error.value = "Sorry, something wet wrong!";
                }

              }

            } else {
              // new encounter
              response.value.encounter_date_end = formattedDate;
              response.value.encounter_cluster_id = props.cluster.id,
              response.value.provider_id = props.cluster.provider_id,
              response.value.stores = newStores;
              response.value.status = "n"; // new
              // kill addOns
              addOns.value = false;
              // clear
              clearAllSpecial();
            }

            // end
            isLoading.value = false;

          } else {
            // addOns
            addOns.value = true;
            // addOns
            let newStores = { ...response.value?.stores }
            if (newStores?.doctor) { doctor.value = newStores?.doctor }
            if (newStores?.age) { patientAge.value = newStores?.age }
            if (newStores?.complaint) { presentingComplaint.value = newStores?.complaint }
            if (newStores?.finding) { examinationFinding.value = newStores?.finding }
            if (newStores?.investigation) { requestedInvestigation.value = newStores?.investigation }
          }

        }

      } else {
        error.value = "Date is Invalid!";
      }
    };

    // handle special
    const handleSpecial = () => {
      handleEncounterDateEnd();
    }

    // handle add on
    const handleAddOn = async () => {

      // start
      isLoading.value = true;

      // stores
      let newStores = { ...response.value?.stores }
      newStores.doctor = doctor.value;
      newStores.age = patientAge.value;
      newStores.complaint = presentingComplaint.value;
      newStores.finding = examinationFinding.value;
      newStores.investigation = requestedInvestigation.value;

      // start
      const newVal = {
        id: response.value.id,
        stores: newStores,
      };

      // post item
      const { res } = await putItem(
        "encounter",
        response.value.id,
        newVal,
      );

      if (res.value) {
        // reset entire encounter data
        response.value = res.value.data;
        handleSubmit(false);
        // clear
        doctor.value = null;
        patientAge.value = null;
        presentingComplaint.value = null;
        examinationFinding.value = null;
        requestedInvestigation.value = null;
      } else {
        error.value = "Sorry, something wet wrong!";
      }

      // end
      isLoading.value = false;
    }

    // handle addon review
    const handleReviewAddOn = () => {
      // stores
      let newStores = { ...response.value?.stores }
      doctor.value = newStores?.doctor;
      patientAge.value = newStores?.age;
      presentingComplaint.value = newStores?.complaint;
      examinationFinding.value = newStores?.finding;
      requestedInvestigation.value = newStores?.investigation;
      // remove store
      // newStores.doctor = null;
      // newStores.age = null;
      // newStores.complaint = null;
      // newStores.finding = null;
      // finish
      // response.value.stores = { ...newStores }
    }

    // date reset
    const handleDateReset = () => {
      // memory (aproko Vue)
      cache.value.encounter_date = response.value.encounter_date;
      // delete start date
      delete response.value.encounter_date;
      // memory (aproko Vue)
      cache.value.encounter_date_end = response.value.encounter_date_end;
      // delete end date
      delete response.value.encounter_date_end;
      // clear date values
      handleClearID("date");
    }

    // haandle clear
    const handleClearID = (val) => {
      if (val == "id") {
        enrolleeGroup.value = [];
        enrolleeId.value = null;
        enrolleeName.value = null;
        response.value = null;
        error.value = false;
      }

      if (val == "date") {
        encounterDate.value = null;
        encounterDateEnd.value = null;
        error.value = false;
      }
    };

    // handle Emitted update
    const handleUpdate = (val) => {
      claimsDisplayCard.value = val.claimsDisplayCard;
      claimsSubmitCard.value = val.claimsSubmitCard;
      diagnosisList.value = [...val.diagnosisList];
      submitPulse.value = val.submitPulse;
      deleteId.value = val.deleteId;
      cache.value = val.cache;

      if (hasBillingDiagnosis()) {
        completionError.value = "";
      }
    };

    const handleClaimsUpdated = (payload) => {
      const claimItems = Array.isArray(payload?.claims) ? payload.claims : [];
      const updatedClaims = [...claimItems];
      claimsList.value = updatedClaims;

      if (response.value) {
        response.value.claims = updatedClaims;
      }
    };

    // handle edit
    const handleEdit = (val) => {
      claim.value = { action: "edit", claim: val };
      editId.value = val.id;

      // top
      router.push({ hash: "#claim" });
    };

    // handle delete
    const handleDelete = (val) => {
      claim.value = { action: "delete", claim: val };
    };

    // handle remove (passed as props)
    const handleReviewDiagnosis = () => {
      resetDiagnosis.value = true;
    };

    // handle next
    const handleNext = (val) => {
      next.value = val;

      // top
      router.push({ hash: "#claim" });
    };

    // handle clear (emiited)
    const handleClear = (val) => {
      if (val.id == "resetDiagnosis") {
        resetDiagnosis.value = val.value;
      } else if (val.id == "claim") {
        claim.value = val.value;
      } else if (val.id == "next") {
        next.value = val.value;
      } else if (val.id == "editId") {
        editId.value = val.value;
      }
    };

    // enrollee delete
    const handleDeleteEncounter = async (val) => {
      if (val === "delete") {

        // send to confirm
        forDelete.value = true;
        // active buttons
        isSubmitting.value = false;

      } else if (val === "confirm_delete") {

        // disable buttons
        isSubmitting.value = true;
        // set as delete

        // enrollee without authorization approved
        if (enrollee.value?.encounter_date_set && !enrollee.value?.claims?.find(x => x.authorization === 'y')) {
          let newVal = await dryDeleteEncounter(enrollee.value.id);
          if (newVal) { response.value.status === "d" }
        }

        // new encounter
        if (!enrollee.value?.encounter_date_set) {
          // clear new
          response.value = null;
        }

        // submit
        await handleSubmit(true, false);

      } else if (val === "back") {

        // clear
        forDelete.value = false;
        // active buttons
        isSubmitting.value = false;

      }
    }

    // handleCreate
    const handleCreate = async () => {
      if (!hasBillingDiagnosis()) {
        await requireBillingDiagnosis();
        return;
      }

      // start
      isSubmitting.value = true;
      isLoading.value = true;
      completionError.value = "";
      // clear error
      error.value = false;

      // if not saved
      if (!enrollee.value?.encounter_date_set) {
        // update encounter
        response.value.diagnosis = diagnosisList.value.join(", ");
        // grab non-reactive copy
        const enrolleeCopy = JSON.parse(JSON.stringify(enrollee.value));
        // create
        let newVal = await addEncounterWithClaims(enrolleeCopy);
        if (newVal) { 
          let updatedVal = newVal;
          // load update  
          updatedVal.claims.forEach((claim) => {
                    claim.claim = claim.item
                    claim.qty = claim.sent_qty
                    claim.amt = claim.sent_price
                    claim.standard = claim.standard_price
                });
          // set response
          response.value = updatedVal;    
          // send away          
          await handleSubmit(true, true);
        } else {
          error.value = "Sorry, Something went wrong!"; // stay
        }

      }

      // end
      isSubmitting.value = false;
      isLoading.value = false;

    }

    // final submit
    const handleBack = () => {
      // send out  
      setTimeout(function () {
        context.emit("back", true);
        // end
        isLoading.value = false;
      }, 10);
    };

    // final submit
    const handleSubmit = async (submit, allowStatusTransition = false) => {

      if (
        submit
        && allowStatusTransition
        && response.value?.encounter_date_set
        && response.value?.status === "q"
        && !hasBillingDiagnosis()
      ) {
        await requireBillingDiagnosis();
        return;
      }

      completionError.value = "";

      // set pass
      let pass = true;

      // start loading
      isLoading.value = true;

      // save encounter after end encounter date set
      if (response.value?.encounter_date_set && submit && allowStatusTransition) {

        // function
        if (response.value.status === "q") {

          // reset pass
          pass = false;
          // start submission
          isSubmitting.value = true;

          // start
          const newVal = {
            id: response.value.id,
            status: "p", // set away from q
          };

          // post item
          const { res, err } = await putItem(
            "encounter",
            response.value.id,
            newVal,
          );

          if (res.value) {
            // reset entire encounter data
            response.value.status = res.value.data.status;
            // reset pass
            pass = true;
          } else {
            completionError.value = err.value || "The encounter could not be submitted.";
          }

        }

      }

      // go
      if (pass) {
        context.emit("next", {
          encounter: enrollee.value,
          submit: submit,
        });
      }

      // end
      isSubmitting.value = false;
      isLoading.value = false;

    };

    // output results
    const enrollee = computed(() => {
      if (!response.value) {
        return null;
      } else {
        return response.value;
      }
    });

    // output claims results
    const claims = computed(() => {
      if (!claimsList.value) {
        return [];
      } else {
        return claimsList.value;
      }
    });

    // get option
    const handlePick = (val) => {
      selectedItem.value = val;
      // watchEffect will take over from here
    };

    // search watcher
    watchEffect(() => {
      // start
      if (selectedItem.value) {
        // sort
        if (selectedItem.value.id == "filterDurationMonth") {
          //set
          if (!selectedItem.value.value) {
            selectedDurationMonth.value = null;
          } else {
            responseDurationMonthDefault.value.value.forEach((x) => {
              if (x.period == selectedItem.value.value) {
                // found
                selectedDurationMonth.value = {
                  name: x.period,
                  search: x.month,
                };
              }
            });
          }
        } else if (selectedItem.value.id == "filterDurationYear") {
          //set
          if (!selectedItem.value.value) {
            selectedDurationYear.value = null;
          } else {
            responseDurationYearDefault.value.value.forEach((x) => {
              if (x.period == selectedItem.value.value) {
                // found
                selectedDurationYear.value = { name: x.period, search: x.year };
              }
            });
          }
        }
      }
    });


    return {
      lock,
      enrolleeSearch,
      healthClaimForm,
      tariffLookup,
      error,
      isLoading,
      isSubmitting,
      capWords,
      showAgeSex,
      handleDownload,
      handleStart,
      handleAddEnrollee,
      handleSearch,
      handlePick,
      handleDateReset,
      handleEncounterDate,
      handleEncounterDateEnd,
      handleSpecial,
      handleAddOn,
      handleReviewAddOn,
      handleClearID,
      handleEdit,
      handleReviewDiagnosis,
      handleDelete,
      handleUpdate,
      handleClaimsUpdated,
      handleNext,
      handleDeleteEncounter,
      handleCreate,
      handleBack,
      handleSubmit,
      handleClear,
      totalSent,
      editId,
      deleteId,
      forDelete,
      claimsDisplayCard,
      claimsSubmitCard,
      selectedItem,
      filterDurationMonthData,
      filterDurationYearData,
      selectedDurationMonth,
      selectedDurationYear,
      resetDiagnosis,
      diagnosisList,
      completionError,
      editClaim,
      deleteClaim,
      submitPulse,
      claimsList,
      next,
      type,
      claim,
      claims,
      enrolleeGroup,
      enrolleeId,
      enrolleeName,
      enrollee,
      encounterDate,
      encounterDateEnd,
      addOns,
      doctor,
      patientAge,
      presentingComplaint,
      examinationFinding,
      requestedInvestigation,
      provider,
      admission,
    };
  },
};
</script>

<style scoped>
.progress {
  margin-top: -15px;
}

.billing-completion-error {
  background: #fff4f2;
  border: 1px solid #ef9a9a;
  color: #b71c1c;
  margin: 0 0 14px;
  padding: 12px 16px;
}

.progresss {
  margin-top: -10px;
}

.progresssave {
  margin-top: -15px;
}

.clickable {
  cursor: pointer;
}

.counter {
  display: block;
  border-radius: 50%;
  background-color: #f2f3f4;
  padding: 0.5em;
}

.spacer5 {
  padding-top: 5px;
  padding-bottom: 5px;
}

.spacer10 {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
